import { useMemo } from 'react';
import { useSearchParams } from 'react-router-dom';
import { URL_PARAMS } from '@/utils/query-url-params';

const FILTER_PARAMS = [
    URL_PARAMS.SOURCES,
    URL_PARAMS.EXCLUDED,
    URL_PARAMS.DATE_TIME,
    URL_PARAMS.SORT,
    URL_PARAMS.CONFIDENCE,
    URL_PARAMS.OBJECT_TYPES,
] as const;

export function useHasUrlFilters(): boolean {
    const [searchParams] = useSearchParams();

    return useMemo(
        () => FILTER_PARAMS.some((param) => searchParams.get(param)),
        [searchParams],
    );
}
